<app-loader *ngIf="isDisabled"></app-loader>
<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        Remark Data
    </div>
    <div class="card-body p-1" style="overflow: auto;">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col" style="width: 5px;">#</th>
                    <th>Employee Code</th>
                    <th style="width: 100px;">Employee Name</th>
                    <th style="width: 10px;">Assigned by</th>
                    <th style="width: 50px;">Assigned To</th>
                    <th style="width: 80px;">Assigned On</th>
                    <th style="width: 80px;">Remarks</th>
                    <th style="width: 80px;">Last Action On</th>
                    <th style="width: 80px;">Remark By </th>
                    <th style="width: 80px;">Attachment</th>
                    <th style="width: 80px;">Status</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let TableData of SupportData; let i = index">
                    <th scope="row" style="width: 5px;">{{i+1}}</th>
                    <td>{{TableData['EmpCode']}}</td>
                    <td style="width: 100px;">{{TableData['EmpName']}}</td>
                    <td style="width: 10px;">{{TableData['AssignedBy']}}</td>
                    <td style="width: 50px;">{{TableData['AssignedTo']}}</td>
                    <td style="width: 50px;">{{TableData['AssignedOn']}}</td>
                    <td style="width: 10px;">{{TableData['Remarks']}}</td>
                    <td style="width: 10px;">{{TableData['LastActionOn']}}</td>
                    <td style="width: 10px;">{{TableData['RemarkBy']}}</td>
                    <!-- <td style="width: 10px;">{{TableData['Attachment']}}</td> -->

                    <td class="text-center"><a [href]="Link(TableData['Attachment'])" target="_blank"
                            *ngIf="(TableData['Attachment'] == '' || TableData['Attachment'] == null)?false:true"><i
                                class="bi bi-paperclip" style="font-size: 1.5rem;"></i></a></td>

                    <td style="width: 10px;">{{TableData['Status']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-outline-primary" name="cancel" (click)="Close()">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>